export const styleInnerHtmlLinks = (html: string): string => {
  // remove class attribute from links
  const linksWithoutClass = html.replace(
    /<a([^>]*)class="[^"]*"([^>]*)>/g,
    '<a$1$2>',
  );
  // add webex class
  return linksWithoutClass.replace(/<a /g, '<a class="webex-link" ');
};
